import React, { useState, useEffect } from "react";
// @ts-ignore
import avatar from "../assets/images/avatar.png";
// @ts-ignore
import iris from "../assets/images/iris.png";
import "../styles/ConciergePopup.scss";

interface Action {
	icon: string;
	text: string;
	action: () => void;
	bgColor: string;
	textColor: string;
	hide_action?: boolean;
}

const ConciergePopup = ({ onMessageClicked, onOpenChat, config }) => {
	const [isVisible, setIsVisible] = useState(false);
	const [isTyping, setIsTyping] = useState(true);
	const pop_up_list = config?.pop_up_list || [];

	const getActions = (): Action[] => {
		return [
			{
				icon: "fas fa-user-md",
				text: pop_up_list.length > 0 ? pop_up_list[0] : "Find/Schedule Doctor",
				action: () => {
					onMessageClicked("find a doctor");
					handleClose();
				},
				bgColor: config?.brand_primary_bg_color || "#0066FF",
				textColor: config?.brand_primary_text_color || "#FFFFFF"
			},
			{
				icon: "fas fa-capsules",
				text: pop_up_list.length > 0 ? pop_up_list[1] : "Learn About " + (config?.brand_name || "Brekiya"),
				action: () => {
					handleClose();
					onMessageClicked("about " + (config?.brand_name || "Brekiya"));
				},
				bgColor: config?.brand_secondary_bg_color || "#0066FF",
				textColor: config?.brand_secondary_text_color || "#FFFFFF",
				hide_action: config?.topic_name === "jatenzo"
			},
			{
				icon: "fas fa-hand-holding-usd",
				text: pop_up_list.length > 0 ? pop_up_list[2] : "Get Cost Support",
				action: () => {
					handleClose();
					onMessageClicked("get cost support");
				},
				bgColor: config?.brand_tertiary_bg_color || "#0066FF",
				textColor: config?.brand_tertiary_text_color || "#FFFFFF",
				hide_action: config?.topic_name === "voquezna-hcp"
			},
			{
				icon: "fas fa-headset",
				text: pop_up_list.length > 0 ? pop_up_list[3] : "Talk to Live Concierge",
				action: () => {
					handleClose();
					onOpenChat();
				},
				bgColor: config?.brand_primary_bg_color || "#0066FF",
				textColor: config?.brand_primary_text_color || "#FFFFFF"
			},
			{
				icon: "fas fa-map-marker-alt",
				text: pop_up_list.length > 0 ? pop_up_list[4] : "Find a Pharmacy",
				action: () => {
					handleClose();
					onOpenChat();
				},
				bgColor: config?.brand_secondary_bg_color || "#0066FF",
				textColor: config?.brand_secondary_text_color || "#FFFFFF",
				hide_action:
					config?.topic_name === "brenzavvy" ||
					config?.topic_name === "pemgarda" ||
					config?.topic_name === "wakix" ||
					config?.topic_name === "qlosi" ||
					config?.topic_name === "austedo" ||
					config?.topic_name === "zepbound" ||
					config?.topic_name === "nexlizet" ||
					config?.topic_name === "nexlizet-hcp" ||
					config?.topic_name === "kerendia" ||
					config?.topic_name === "ultomiris" ||
					config?.topic_name === "lupkynis" ||
					config?.topic_name === 'qelbree' ||
					config?.topic_name === 'unithroid' ||
					config?.topic_name === 'leqvio' ||
					config?.topic_name === 'voquezna' ||
					config?.topic_name === 'actemra' ||
					config?.topic_name === 'adbry-hcp' ||
					config?.topic_name === 'anzupgo-hcp'
			}
		];
	};

	useEffect(() => {
		// Show popup after a short delay when component mounts
		const timer = setTimeout(() => {
			setIsVisible(true);
		}, 2000);

		// Simulate typing effect
		const typingTimer = setTimeout(() => {
			setIsTyping(false);
		}, 4000);

		return () => {
			clearTimeout(timer);
			clearTimeout(typingTimer);
		};
	}, []);

	const handleClose = () => {
		setIsVisible(false);
	};

	if (!isVisible) return null;

	return (
		<>
			<div className="concierge-backdrop" onClick={handleClose} />
			<div className="concierge-popup">
				<div className="concierge-header">
					<div className="header-content">
						<div
							className="contact-options"
							onClick={() => {
								onOpenChat();
								handleClose();
							}}
						>
							<span className="contact-badge">
								<i className="fas fa-phone"></i> Call
							</span>
							<span className="contact-badge">
								<i className="fas fa-comment-alt"></i> Text
							</span>
						</div>
						<button
							className="close-btn"
							onClick={handleClose}
							aria-label="Close chat"
						>
							<i className="fas fa-times"></i>
						</button>
					</div>
				</div>

				<div className="concierge-content">
					<div className="avatar-container">
						<img src={config?.concierge_name?.toLowerCase() === 'iris' ? iris : avatar} alt="Alex from Brekiya" className="avatar" />
						<div className="status-indicator">
							<span className="status-text">LIVE</span>
						</div>
					</div>

					<div className="concierge-message">
						<h3>Hi, I'm {config?.concierge_name || "Alex"}!</h3>
						<div className="typing-container">
							{isTyping ? (
								<div className="typing-indicator">
									<span></span>
									<span></span>
									<span></span>
								</div>
							) : (
								<p>How can I help you today?</p>
							)}
						</div>
					</div>

					<div className="action-buttons">
						{getActions()
							.filter(action => !action.hide_action)
							.map((action, index) => (
							<button
								key={index}
								className="action-btn"
								style={{
									backgroundColor: action.bgColor,
									color: action.textColor,
								}}
								onClick={action.action}
							>
								<div className="icon-container">
									<i className={action.icon}></i>
								</div>
								{action.text}
							</button>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

export default ConciergePopup;
